<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="room.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Филиал</label>
            <crm-filial-single-select
              [(selectedFilial)]="room.filial"
              [isError]="$any(errors?.filial)"
              [showClear]="true"
              appendTo="body"></crm-filial-single-select>
            <small
              *ngIf="errors?.filial"
              class="p-error">
              {{ errors.filial | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Площадь</label>
            <p-inputNumber
              [(ngModel)]="room.square"
              [ngClass]="{ 'ng-invalid ng-dirty': errors?.square }"
              [minFractionDigits]="2"
              class="w-full"
              styleClass="w-full"
              suffix=" м²">
            </p-inputNumber>
            <small
              *ngIf="errors?.square"
              class="p-error">
              {{ errors.square | join }}
            </small>
          </div>

          <div
            *ngIf="globalService.isEnableModule('PACS')"
            class="field">
            <label class="font-medium">Оборудование</label>
            <crm-converter-multi-select
              [(selectedConverters)]="room.converters"
              [isError]="$any(errors?.converters)"
              [isFloatLabel]="false"
              appendTo="body"></crm-converter-multi-select>
            <small
              *ngIf="errors?.converters"
              class="p-error">
              {{ errors.converters | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Клиент</label>
            <crm-client-auto-complete
              [(selectedClient)]="room.client"
              [isError]="$any(errors?.client)"
              [customSearch]="false"
              appendTo="body"></crm-client-auto-complete>
            <p
              *ngIf="errors?.client"
              class="p-error">
              {{ errors.client | join }}
            </p>
          </div>

          <div class="field">
            <label class="font-medium">Пользователи</label>
            <crm-user-multi-select
              [(selectedUsers)]="room.allowUsers"
              [isError]="$any(errors?.allowUsers)"
              [isFloatLabel]="false"
              appendTo="body"></crm-user-multi-select>
            <p
              *ngIf="errors?.allowUsers"
              class="p-error">
              {{ errors.allowUsers | join }}
            </p>
          </div>
        </div>
      </p-card>
    </div>
  </div>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <button
        pButton
        [label]="saveButtonLabel"
        class="p-button-success"
        (click)="saveRoom()"></button>
      <button
        *ngIf="(form$ | async)?.isShowDelete"
        pButton
        label="Удалить"
        class="p-button-danger p-button-text"
        (click)="deleteRoom()"></button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
